import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';


import enCommon from '../locales/en/common';
import enManageUser from '../locales/en/manageuser';
import enDashboardtxt from '../locales/en/dashboardtxt';

import isCommon from '../locales/is/common';
import isManageUser from '../locales/is/manageuser';
import isDashboardtxt from '../locales/is/dashboardtxt';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
              fallbackLng: 'en',
              supportedLngs: ['en', 'is'],
              defaultNS: 'common',
              ns: ['common', 'manageuser', 'dashboard'],
              resources: {
                  en: {
                      common: enCommon,
                      manageuser: enManageUser,
                      dashboard: enDashboardtxt,
                  },
                  is: {
                      common: isCommon,
                      manageuser: isManageUser,
                      dashboard: isDashboardtxt,
                  },
              },
              interpolation: {
                  escapeValue: false,
              },
          });

export default i18n;
